const baseUrl = process.env.REACT_APP_OPENINGS_API_URL?.replace(/\/$/, '');
export const savingAvailable = Boolean(baseUrl);

export async function openingRequest(path, auth, method = 'GET', body) {
  if (!baseUrl) throw new Error('Cloud saving is not available yet. You can still try a sample line.');
  const response = await fetch(`${baseUrl}/opening-sets${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth.idToken}`,
      'X-Authorization-Provider': auth.authProvider,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error(data.error || 'Opening training is unavailable. Please retry.');
    error.status = response.status;
    throw error;
  }
  return data;
}
